import { gql } from '@apollo/client'

const GET_FUNDER_USERS = gql`
  query getFunderUsers($funderOrgId: Int!) {
    getFunderUsers(funderOrgId: $funderOrgId) {
      user {
        id
        email
        firstName
        lastName
      }
      role
      funderOrgRole
      lastInviteSentAt
      funderOrgId
    }
  }
`

export default GET_FUNDER_USERS
